const env = process.env.VUE_APP_ENV;

let envApiUrl = '';

if (env === 'production') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_PROD}`;
} else if (env === 'staging') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_STAG}`;
} else {
  envApiUrl = `http://${process.env.VUE_APP_DOMAIN_DEV}`;
  // console.log(envApiUrl);
  // console.log(Date());
}

export const apiUrl = envApiUrl;
export const appName = process.env.VUE_APP_NAME;
export const canDebug = env === 'development';
export const commonPrefix = process.env.VUE_APP_COMMON_PREFIX; 
